module.exports = __webpack_public_path__ + "static/images/details-3.4951ef8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/product/ssk/details-3.png
// module id = B0Bd
// module chunks = 0